/**
 * The `useInternalId` hook assists and standardizes generating internal id's which
 * intentionally vary at run-time so that consumers of components do not introspect
 * and rely on the internal implementation details of your component.
 */
import * as React from "react"
import useEnvironment from "../Environment/useEnvironment"

const useInternalId = (prefix: number | string) => {
  const { generateInternalId } = useEnvironment()
  //  keeps the Id from changing on component re-render
  const internalId = React.useRef(generateInternalId())
  return `${prefix}_${internalId.current}`
}

export default useInternalId
